<div class="modal-body">
    <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
    <cm-dynamic-form
        [isZeroValueAllowed]="true"
        [elements]="elements"
        [disabled]="isStepSubmitted || disabled"
        [showErrors]="showErrors"
        [sections]="sections"
    ></cm-dynamic-form>
    <div class="form-errors" [ngClass]="{ 'show-errors': showErrors }">
        <p *ngFor="let errorText of dynamicFormErrors">{{ errorText }}</p>
    </div>
    <cm-signature *ngIf="isStepSubmitted && signatureLink" class="signature-bar" [editable]="false"></cm-signature>
</div>
<div class="modal-footer">
    <button type="button" *ngIf="!isStepSubmitted && isFirstPage" class="btn btn-default" (click)="dismissModal()">
        CLOSE
    </button>
    <button
        *ngIf="isResetEnabled && workflowTypeId === WORKFLOW_MODULE_ID.CREDENTIAL"
        type="button"
        class="btn btn-default"
        (click)="onScreenChange(PAGES.RESET_CONFIRM)"
    >
        RESET
    </button>
    <button
        *ngIf="!isStepSubmitted && !isFirstPage"
        type="button"
        class="btn btn-default"
        (click)="onScreenChange(PAGES.BACK)"
    >
        BACK
    </button>
    <button *ngIf="!isStepSubmitted" type="button" class="btn btn-primary" (click)="submitForm()" [disabled]="disabled">
        CONTINUE
    </button>
    <button *ngIf="isStepSubmitted" type="button" class="btn btn-primary" (click)="dismissModal()">CLOSE</button>
</div>
